import { Link } from "react-router-dom";
export default function Service() {

    return (
        <div className="service">
            <section className="team mt-2" id="team" style={{background:"#17a2b8"}}>
                <div className="row justify-content-center mx-2">
                    <div className="col-12 text-center">
                        <div className="section-title" >
                            <h2 style={{ color: "#ffffff" }}>Services</h2>
                            <p></p>
                        </div>
                    </div>
                    <div className="col-sm-6 col-6 my-1" data-aos="zoom-in-up" data-aos-delay={100}>
                        <Link to="/tutor"><div className="card rounded-top" >
                            <img src={require("../../../assets/img/img1.jpg")} style={{ height: "200px" }} className="img-fluid" alt="pic" />
                            <div className="card-body">
                                <div className="card-info-content py-2">
                                    <h4>Tutor</h4>
                                </div>
                            </div>
                        </div></Link>
                    </div>
                    <div className="col-sm-6 col-6 my-1" data-aos="zoom-in-up" data-aos-delay={100}>
                        <Link to="/mess"><div className="card" >
                            <img src={require("../../../assets/img/img2.jpg")} style={{ height: "200px" }} className="img-fluid" alt="pic" />
                            <div className="card-body">
                                <div className="card-info-content py-2">
                                    <h4>Mess/Flat</h4>
                                </div>
                            </div>
                        </div></Link>
                    </div>
                </div>
            </section>
        </div>)

}